export enum KimThreadStatus {
  Ready = 'ready', // Ready when a user has read any new messages in a thread
  Composing = 'composing', // Composing when Kim is generating a response
  InProgress = 'in-progress',
  Complete = 'complete', // Complete when an answer has been delivered but not read yet
  Failed = 'failed',
}
